import detectClick from './_detectClick'
// import detectSubmit from './_detectSubmit'

export default () => {
  detectClick()
}